module.exports = __webpack_public_path__ + "static/media/dots.fb749a2f.gif";